<template>
    <div class="strategy_wrapper">
        <div class="btn_list_wrapper">
            <div class="menu_icon"><v-btn @click="multipleDel">批量删除</v-btn></div>
            <div class="menu_icon"><v-btn @click="merge('AND')">合并(与)</v-btn></div>
            <div class="menu_icon"><v-btn @click="merge('OR')">合并(或)</v-btn></div>
            <div class="menu_icon"><v-btn @click="merge('NOT')">合并(非)</v-btn></div>
        </div>
        <v-data-table
                v-model="selectKeys"
                item-key="id"
                :headers="headers"
                :items="list"
                show-select
                disable-pagination
                hide-default-footer
                class="elevation-1"
            >
                <template v-slot:item.nameItem="{item}">
                    <div class="overflow2" >
                       <span>{{item.name}}</span>
                    </div>
                </template>
                <template v-slot:item.valueItem="{item}">
                    <div class="overflow2" >
                       <span>{{item.value}}</span>
                    </div>
                </template>
                <template v-slot:item.rangeItem="{item}">
                    <div class="overflow2">
                       <span>{{item.range}}</span>
                    </div>
                </template>
                <template v-slot:item.action="{item}">
                    <div class="btn_list_wrapper">
                        <div class="menu_icon" @click="editItem(item)" title="修改"><v-icon>mdi-pencil-box</v-icon></div>
                        <div class="menu_icon" @click="delItem(item)" title="删除"><v-icon>mdi-delete</v-icon></div>
                        <div class="menu_icon" @click="searchItem(item)" title="搜索"><v-icon>mdi-card-search</v-icon></div>
                    </div>
                </template>
        </v-data-table>
        <div class="common_page">
              <v-pagination
                v-model="currentPage"
                :length="length"
                ></v-pagination>
        </div>
        <v-dialog v-model="strateDialog" width="60%">
            <v-card class="country_dialog">
                <v-card-title class="headline lighten-2">编辑检索式</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="addSpace_wrapper">
                        <div class="common_input_style margbsm">
                            <v-text-field
                            label=""
                            hide-details
                            outlined
                            v-model="editInfo.name"
                            ></v-text-field>
                        </div>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                    @click="handleEditCancel">
                    取消
                    </v-btn>
                    <v-btn
                    color="primary"
                    @click="handleEditOk">
                    保存
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    props: ['queryList'],
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            list: [],
            total: 0,
            selectKeys: [],
            // length: 1,
            strateDialog: false,
            editInfo: {},
            headers: [
                {
                    text: '引用标识',
                    align: 'start',
                    sortable: false,
                    value: 'idn'
                },
                {
                    text: '名称',
                    align: 'start',
                    sortable: false,
                    value: 'nameItem'
                },
                {
                    text: '检索式',
                    align: 'start',
                    sortable: false,
                    value: 'valueQuery'
                },
                {
                    text: '	检索范围',
                    align: 'start',
                    sortable: false,
                    value: 'rangeItem'
                },
                {
                    text: '	命中数量',
                    align: 'start',
                    sortable: false,
                    value: 'hit'
                },
                {
                    text: '操作',
                    align: 'start',
                    sortable: false,
                    value: 'action'
                },
            ]
        }
    },
    mounted() {
        this.getList()
    },
    computed: {
        length() {
            return Math.ceil(this.total/this.pageSize)
        }
    },
    watch: {
        currentPage(val) {
            this.getList()
        },
        queryList(val) {
            if(val) {
                this.getList()
            }
        }
    },
    methods: {
        ...mapActions('search',['getStrategy','renameStrategy','delStrategy','mergeStrategy']),
        getList() {
            let data = {
                params: {
                    page: this.currentPage,
                    size: this.pageSize
                }
            }
            let _this = this
            this.getStrategy({data: data,handle(res) {
                let list = res.pagination.data
                _this.$emit('setQuery', false)
                _this.total = res.pagination.total
                _this.list = list
            }})
        },
        delItem(val) {
            this.$msgbox.confirm('此操作将永久删除该检索式, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    params: {
                        ids: val.id
                    } 
                }
                let _this = this
                this.delStrategy({data: data,handle(res) {     
                    if(res.success) {
                        _this.getList()
                        _this.$message({
                            type: 'success',
                            message: '删除成功'
                        });  
                    }else {
                        _this.$message({
                            type: 'error',
                            message: '删除失败'
                        });  
                    }
                }})
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        searchItem(val) {
            this.$router.push({
                path: '/search/result',
                query: {
                    str: val.valueQuery
                }
            })
        },
        editItem(val) {
            this.editInfo = val
            this.strateDialog = true
        },
        handleEditOk() {
            let data = {
                params: {
                    id: this.editInfo.id,
                    name: this.editInfo.name
                }
            }
            let _this = this
            this.renameStrategy({data:data,handle(res) {
                _this.strateDialog = false
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    _this.getList()
                }else {
                    _this.$message({
                        type: 'error',
                        message: '修改失败'
                    })
                }
            }})
        },
        handleEditCancel() {
            this.editInfo = {}
            this.strateDialog = false
        },
        multipleDel() {
            if(this.selectKeys.length<=0) {
                this.$message({
                    type: 'info',
                    message: '请选中搜索式再删除'
                })
                return false
            }
            let list = []
            if(this.selectKeys.length>0) {
                list = this.selectKeys.map((item)=>{
                    return item.id
                })
            }
            let key = {
                id: list.join(',')
            }
            this.delItem(key)
        },
        merge(val) {
            if(this.selectKeys.length<=1) {
                this.$message({
                    type: 'info',
                    message: '请选中要合并的检索式'
                })
                return false
            }
            let list = []
            if(this.selectKeys.length>0) {
                list = this.selectKeys.map((item)=>{
                    return item.id
                })
            }
            let data = {
                params: {
                    ids: list.join(','),
                    op: val
                }
            }
            let _this = this
            this.mergeStrategy({data: data,handle(res) {
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: '修改成功'
                    })
                    _this.getList()
                }else {
                    _this.$message({
                        type: 'error',
                        message: '修改失败'
                    })
                }
            }})
        }
    }
}
</script>